import type { filter } from 'utility'

export type ManualReviewRow = {
  'order_id': number
  reason: string
  'affected_item_ids': number[]
}

export function manualReviewFilter (rows: ManualReviewRow[], manual: boolean): filter[] {
  const ids = rows.map(row => row.order_id)
  if (manual) return [{ field: 'id', operator: 'in', value: ids.length ? ids : [0] }]
  return ids.length ? [{ field: 'id', operator: 'notin', value: ids }] : []
}

// Keep this projection minimal: the existing orders query supplies all ordinary
// columns. Manual review membership is authoritative independently of order status.
export async function readManualReview (client: any): Promise<ManualReviewRow[]> {
  const { data, error } = await client.from('manual_review_queue')
    .select('order_id, reason, affected_item_ids').order('order_id', { ascending: true }).limit(1000)
  if (error || !Array.isArray(data)) throw new Error('No se pudo actualizar Revisión manual. Vuelve a intentarlo antes de comprar.')
  return data
}

// Only active purchase records remove a queued order. Status, estimates and
// supplements are deliberately not used to decide manual-review membership.
export async function readUnpurchasedManualReview (client: any): Promise<ManualReviewRow[]> {
  const rows = await readManualReview(client)
  const purchased = new Set<number>()
  for (let offset = 0; offset < rows.length; offset += 200) {
    const ids = rows.slice(offset, offset + 200).map(row => row.order_id)
    for (let start = 0; ; start += 1000) {
      const { data, error } = await client.from('market_orders').select('order_id')
        .in('order_id', ids).eq('deleted', false).range(start, start + 999)
      if (error || !Array.isArray(data)) throw new Error('No se pudo comprobar si los pedidos ya están comprados. Vuelve a intentarlo antes de comprar.')
      data.forEach((row: { 'order_id': number }) => purchased.add(row.order_id))
      if (data.length < 1000) break
    }
  }
  return rows.filter(row => !purchased.has(row.order_id))
}

export const manualReviewSelection = (selection: string): string => selection.replace('marketplace_id!inner(', 'marketplace_id(')
